export default __webpack_public_path__ + "static/media/rewind.8cd29f64.png";